export const COMBAT_TYPE_TERRITORIAL = 'territorial';

export const COMBAT_STATUS_FIGHT = 'fight';
export const COMBAT_STATUS_AFTER_FIGHT = 'afterfight';
export const COMBAT_STATUS_PAST = 'past';

export const COMBAT_TIMEOUT = 60 * 3;

export const CLAN_WAR_STATUS_LOBBY = 'lobby';
export const CLAN_WAR_STATUS_FIGHTING = 'fighting';
export const CLAN_WAR_STATUS_FINISHED = 'finished';

export const BODY_PARTS = ['head', 'breast', 'belly', 'groin', 'legs'];

export const THING_TYPES = {
  SWORD: 'sword',
  AXE: 'axe',
  KNIFE: 'knife',
  CLUBS: 'clubs',
  SHIELD: 'shield',
  RING: 'ring',
  AMULET: 'amulet',
  ELIXIR: 'elixir',
  BELT: 'belt',
  BRACER: 'bracer',
  GLOVES: 'gloves',
  PANTS: 'pants',
  ARMOR: 'armor',
  BOOTS: 'boots',
  HELMET: 'helmet',
  SCROLL: 'scroll',
  CAPE: 'cape',
};

export const THING_NEED_ITEMS = [
  'levelNeed',
  'levelMaxNeed',

  'strengthNeed',
  'dexterityNeed',
  'intuitionNeed',
  'healthNeed',

  'swordsNeed',
  'axesNeed',
  'knifesNeed',
  'clubsNeed',
  'shieldsNeed',
];

export const THING_GIVE_ITEMS = [
  'strength',
  'dexterity',
  'intuition',
  'health',

  'swords',
  'axes',
  'knifes',
  'clubs',
  'shields',

  'damageMin',
  'damageMax',

  'protectionHead',
  'protectionBreast',
  'protectionBelly',
  'protectionGroin',
  'protectionLegs',

  'accuracy',
  'dodge',
  'devastate',
  'durability',

  'blockBreak',
  'armorBreak',

  'hp',
  'capacity',

  'strikeCount',
  'blockCount',
];

export const BUILDING_MODULES = {
  CASTLE: 'castle',
  SHOP: {
    NAME: 'shop',
    ACTIONS: {
      BUY: 'buy',
      BUY_CRYPTO: 'buyCrypto',
      BUY_IAP: 'buyIap',
      SELL: 'sell',
    },
  },
  FORGE: {
    NAME: 'forge',
    ACTIONS: {
      REPAIR: 'repair',
      REPAIRE_ALL_RED: 'repairAllRed',
    },
  },
  AVATAR_SHOP: {
    NAME: 'avatarShop',
    ACTIONS: {
      BUY: 'buy',
      BUY_IAP: 'buyIap',
      APPLY: 'apply',
    },
  },
  PORTAL: {
    NAME: 'portal',
    ACTIONS: {
      TELEPORT: 'teleport',
    },
  },
  ARENA: {
    NAME: 'arena',
    ACTIONS: {
      FIND_MATCH: 'findMatch',
    },
  },
};

export const THING_ACTIONS = {
  RESETS_STATS: 'resetStats',
  PREVENT_ATTACK: 'preventAttack',
  INCREASE: 'increase',
  ADD_MONEY: 'addMoney',
};

export const DURATION_IMMEDIATE = -1;

export const PAYMENT_ITEMS_TYPES = {
  AVATAR: 'AVATAR',
};

export const PAYMENT_STATUS = {
  APPROVED: 'Approved',
};

export const PAYMENT_TYPES = {
  WEB: 'WEB',
  APPLE_PAY: 'APPLE_PAY',
  GOOGLE_PAY: 'GOOGLE_PAY',
};
